
// import libs
// import cookieBar from './libs/cookieBar';
// import { CountUp } from './libs/CountUp.js';

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
// import './components/ie-edge-detection.js';
import './components/menu.js';
// import './components/numbers';

// import './components/animations.js';
// import './components/animation2.js';

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function throttle (callback, limit) {
  var wait = false;
  return function () {
    if (!wait) {
      callback.apply(null, arguments);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  }
}

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// init

const mqMobile = window.matchMedia( "(max-width: 991px)" );
const mqMobileXS = window.matchMedia( "(max-width: 575px)" );

// AOS animations
// if (mqMobile.matches) {
  AOS.init({
    once: true,
    // disable: 'mobile'
  });  
// }

// ----------------------------------------
//  scroll to
function scrollTo(e) {
  e.preventDefault();

  var href = $.attr(this, 'href');
  if (typeof href === 'undefined') {
      href = $.attr(this, 'data-href');
  }
  href = href.replace('/', '');
  href = '#' + href.split('#').pop();

  // console.log(href);

  var offset = $.attr(this, 'data-offset');

  var $target = $(href);
  if ($target.length) {
      $('html,body').animate({
        scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 10)
      }, {
        duration: 500,
        easing: 'swing'
      });
  }
}
$('.scrollTo').on('click', scrollTo);

// ----------------------------------------

// scripts here

// burger
// $('.header__toggle').on('click', function(e){
//   e.preventDefault();
//   $(this).toggleClass('is-active');
//   $('body').toggleClass('menu-active');
// });

$('.nav a').on('click', function(e) {
  $('.nav__toggle').removeClass('is-active');
  $('body').removeClass('menu-active');
});

if ($('#refCarousel').length) {
  var refCarousel = tns({
    container: '#refCarousel',  
    items: 1,
    speed: 1000,
    autoplay: false,
    mouseDrag: true,
    touch: true,
    loop: true,
    nav: false,
    controls: true,
    autoplayButton: false,
    autoplayButtonOutput: false,
  });
}

// $('input, textarea').focus(function(){
//   $(this).parents('.form-group').addClass('focused');
// });

// $('input, textarea').blur(function(){
//   var inputValue = $(this).val();
//   if ( inputValue == "" ) {
//     $(this).removeClass('filled');
//     $(this).parents('.form-group').removeClass('focused');  
//   } else {
//     $(this).addClass('filled');
//   }
// })

// if ($('#projekty, #projects').length) {
//   var $nav = $('.carouselNav');  
//   var referencesCarousel = tns({
//     container: '#projekty,#projects',  
//     items: 1,
//     swipeAngle: false,
//     speed: 400,
//     mouseDrag: true,
//     nav: false,
//     loop: true,
//     controls: true,
//     edgePadding: 0,
//     // gutter: 500,
//     center: true,
//     autoHeight: true,
//     // controlsContainer: $nav,
//     prevButton: '.carouselNav__btn--prev',
//     nextButton: '.carouselNav__btn--next',
//     onInit: function() {
//       var $carouselItems = $('.carousel__item');
//       $('#all').on('click', function(e) {
//         $carouselItems.removeClass('d-none');
//       });
    
//       $('#notAll').on('click', function(e) {
//         $('.carousel__item[data-index="1"]').addClass('d-none');        
//       });
//     },
//     responsive: {
//       576: {
//         edgePadding: 50,        
//       },
//       992: {
//         autoHeight: false,
//       },
//       1200: {
//         edgePadding: 150,
//       },
//       1440: {
//         edgePadding: 200,
//       },
//       1900: {
//         edgePadding: 300,
//       },
//       3600: {
//         edgePadding: 850,
//       }
//     }
//   });

// if ($('#kontakt,#contact').length) {
//   var waypointContactBtn = new Waypoint({
//     element: document.querySelectorAll('#kontakt,#contact'),
//     handler: function(direction) {
//       if (direction == 'up') {
//         $logos.removeClass('active');
//         $logoInspired.addClass('active');        
//       }
//       else {
//         $logos.removeClass('active');
//         $logoInvolved.addClass('active');
//       }
//     },
//     offset: 100
//   });
// }

// input file / click on button
// $('.inputFileButton').on('click', 'button', function(e) {
//   $(this).next('input[type=file]').click();
// });

// $('.inputFileButton input[type=file]').on("change", function(event){

//   var $button = $('.inputFileButton button'); 
	
//   if (event.target.files.length) {
//     var text = '';
//     for (var i = 0; i < event.target.files.length; i++) {
//       text += event.target.files[i].name + ', ';
//     }
  
//     var newText = text.slice(0, -2);
//     $button.text(newText);
//     $button.addClass('active');
//   }
//   else {
//     $button.text($button.attr('data-text'));
//     $button.removeClass('active');
//   }

// });

// const modalContactForm = document.getElementById('modalContactForm')
// modalContactForm.addEventListener('show.bs.modal', event => {
//   // Button that triggered the modal
//   const button = event.relatedTarget
//   // Extract info from data-bs-* attributes
//   const jobId = button.getAttribute('data-bs-job')
//   // If necessary, you could initiate an AJAX request here
//   // and then do the updating in a callback.
//   //
//   // Update the modal's content.
//   // const modalTitle = modalContactForm.querySelector('.modal-title')
//   const modalBodyInput = document.getElementById('contact_form_positionId');

//   // modalTitle.textContent = `New message to ${jobId}`
//   modalBodyInput.value = jobId
// })

$('#volna-mista').find('.accordion').on('click', '.btn', function(e) {
  const jobId = $(this).attr('data-bs-id');
  $('#contact_form_positionId').val(jobId);
});